import { useEffect } from 'react';
import { creditStore } from 'entities/credit';
import { userStore } from 'entities/user';
import { conversationStore } from 'entities/tavus/conversation/model/conversationStore';
import { tavusPersonaStore } from 'entities/tavus/persona';
import { TavusConference } from './TavusConference';
import {
  EPreconversationStatus,
  preconversationStore
} from 'entities/tavus/preconversation';

export const TavusCall = () => {
  const { startConversation } = conversationStore((state) => ({
    startConversation: state.startConversation
  }));
  const { currentPersona } = tavusPersonaStore();
  const { user } = userStore();
  const { isChatAvailable } = creditStore();

  const currentPreconversationId = preconversationStore(
    (state) => state.currentPreconversationId
  );

  useEffect(() => {
    if (user && isChatAvailable && currentPersona) {
      startConversation({
        currentPersona,
        key: undefined,
        language: currentPersona?.default_language || 'english',
        preconversationId: currentPreconversationId
      }).then(() => {
        window.opener.postMessage({
          type: 'CHANGE_STATUS',
          payload: {
            status: EPreconversationStatus.IN_PROGRESS,
            preconversationId: currentPreconversationId
          }
        });
      });
    }
  }, [user, isChatAvailable, currentPersona, currentPreconversationId]);

  return <TavusConference />;
};
